import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true
    },
    {
      field: 'month',
      type: 'datepicker',
      label: '选择月份',
      otherOptions: {
        'value-format': 'YYYY-MM',
        type: 'month'
      }
    }
  ]
}
